import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import ChecksTable from 'dashboard/components/ChecksTable';
import { VerificationDetailProps } from 'dashboard/components/VerificationDetail/types';
import { CheckStatus } from 'dashboard/models/check';
import { VerificationPhoneNumber } from 'dashboard/models/verification';
import Attribute, { AttributeGrid } from 'design-system/components/Attribute';
import { VerificationStatus } from 'lib/verification';

const StyledAttributeGrid = styled(AttributeGrid)`
  padding: 0 ${Spacing[4]} ${Spacing[2]};
`;

const ChecksInformationRow = styled('div')`
  display: grid;
  grid-template-columns: auto;
  grid-row-gap: ${Spacing[4]};
`;

interface PhoneNumberVerificationProps extends VerificationDetailProps {
  verification: VerificationPhoneNumber;
}

const PhoneNumberVerification = ({ verification }: PhoneNumberVerificationProps) => {
  const {
    'phone-number': phoneNumber,
    'num-confirmation-code-attempts': numConfirmationCodeAttempts,
    status,
    'redacted-at': redactedAt,
  } = verification.attributes;

  const isRedacted = redactedAt != null;

  const hasBeenSubmitted = status !== VerificationStatus.Initiated;

  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const checks = verification.attributes.checks.filter(
    (check) => check.status !== CheckStatus.NotApplicable,
  );

  if (hasBeenSubmitted && checks.length > 0) {
    return (
      <ChecksInformationRow data-test='verification-detail__phone-number-verification'>
        <StyledAttributeGrid data-test='verification-detail__phone-number-verification'>
          <Attribute label='Phone number' value={phoneNumber} redacted={isRedacted} />
          {numConfirmationCodeAttempts != null && (
            <Attribute label='Attempts' value={numConfirmationCodeAttempts} />
          )}
        </StyledAttributeGrid>
        {verification.attributes.checks && <ChecksTable checks={verification.attributes.checks} />}
      </ChecksInformationRow>
    );
  } else {
    return (
      <StyledAttributeGrid data-test='verification-detail__phone-number-verification'>
        <Attribute label='Phone number' value={phoneNumber} redacted={isRedacted} />
        {numConfirmationCodeAttempts != null && (
          <Attribute label='Attempts' value={numConfirmationCodeAttempts} />
        )}
      </StyledAttributeGrid>
    );
  }
};

export default PhoneNumberVerification;
